import React from 'react';

const TabContext = /*#__PURE__*/React.createContext({
  disabled: false,
  activeTab: undefined,
  variant: 'primary',
  setActiveTab: () => {
    console.warn('setActiveTab called before it was initialized');
  },
  setEllipsize: () => {
    console.warn('setEllipsize called before it was initialize');
  }
});

export { TabContext };
//# sourceMappingURL=TabContext.js.map
